import React from 'react';
import Dialog from '../../../ui/components/web/Dialog';
const ConfirmDialog = ({ titleKey = 'dialog.confirm', onCancel, onSubmit, children, ok, hideTooltip }) => {
    return (React.createElement(Dialog, { titleKey: titleKey, onCancel: onCancel, onSubmit: onSubmit, ok: ok, hideTooltip: hideTooltip }, children));
};
export default ConfirmDialog;
